/**
 * @packageDocumentation
 * @module Updater
 * @category Core
 */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FlatButtonComponent } from '@app/shared/components/flat-button';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Компонент сообщения о наличии обновления.
 *
 * @example
 * ```ts
 * this.snackBar.openFromComponent(UpdaterComponent, {
 *   panelClass: 'updateMessage',
 *   verticalPosition: 'bottom',
 *   horizontalPosition: 'start',
 * });
 * ```
 *
 * @group Components
 */
@Component({
  templateUrl: './updater.component.html',
  styleUrls: ['./updater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FlatButtonComponent, MatIconButton, MatIcon, TranslatePipe],
})
export class UpdaterComponent {
  private _snackBar = inject(MatSnackBar);

  /**
   * Обновление приложения.
   * Обновление применяется через перезагрузку страницы.
   */
  public update(): void {
    document.location.reload();
  }

  /**
   * Закрыть уведомление.
   */
  public close(): void {
    this._snackBar._openedSnackBarRef?.dismiss();
  }
}
